import { Component, Input, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { DropdownService } from 'src/app/services/dropdown.service';
import { IncidentService } from 'src/app/services/incident.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-artifacts-info',
  templateUrl: './artifacts-info.component.html',
  styleUrls: ['./artifacts-info.component.scss']
})
export class ArtifactsInfoComponent implements OnDestroy {
  @Input() form: FormGroup;

  constructor(
    private dropdownService: DropdownService, 
    private toast: ToastService,
    private incidentService: IncidentService
  ) {}

  departments: any[] = ['N/A', 'Air Operations', 'Loadmaster', 'Operations', 'Loft', 'Training'];

  filteredWitnesses$: Observable<any[]>;
  filteredForeman$: Observable<any[]>;

  // File/Photo upload properties
  selectedFileOne: any;
  selectedFileTwo: any;
  selectedFileThree: any;
  selectedFileOneName: string = '';
  selectedFileTwoName: string = '';
  selectedFileThreeName: string = '';
  selectedFileOneImgSrc: any; 
  selectedFileTwoImgSrc: any;
  selectedFileThreeImgSrc: any;
  selectedVideo: any;
  selectedVideoName: string = '';
  selectedVideoSrc: any;
  selectedVideoType: string = '';
  relativePathToUploadedFiles: string = 'uploaded-files'
  deletePhotoSub: any;
  deleteVideoSub: any;

  deletePhoto = (slotNumber) => {
    if (!this.form.get(`pic${slotNumber}toUpload`)?.value) {
      this.deletePhotoSub = this.incidentService.deleteMedia(this.form.get('incidentId')?.value, slotNumber).subscribe({
        next: (response) => {
          this.toast.show(response, 'success');
          this.form.get(`picId${slotNumber}`)?.patchValue('');
          this.form.get(`pic${slotNumber}toUpload`)?.patchValue('');
          this.form.get(`picPreview${slotNumber}`)?.patchValue('');
          if (slotNumber === 1) {
            this.selectedFileOneImgSrc = '';
            this.selectedFileOneName = '';
          } else if (slotNumber === 2) {
            this.selectedFileTwoImgSrc = '';
            this.selectedFileTwoName = '';
          } else if (slotNumber === 3) {
            this.selectedFileThreeImgSrc = '';
            this.selectedFileThreeName = '';
          }
        },
        error: (error) => {
          this.toast.show('Error deleting media', 'error');
        }
      });
    } else {
      this.form.get(`picId${slotNumber}`)?.patchValue('');
      this.form.get(`pic${slotNumber}toUpload`)?.patchValue('');
      this.form.get(`picPreview${slotNumber}`)?.patchValue('');
      if (slotNumber === 1) {
        this.selectedFileOneImgSrc = '';
        this.selectedFileOneName = '';
      } else if (slotNumber === 2) {
        this.selectedFileTwoImgSrc = '';
        this.selectedFileTwoName = '';
      } else if (slotNumber === 3) {
        this.selectedFileThreeImgSrc = '';
        this.selectedFileThreeName = '';
      }
    }
  }

  deleteVideo = () => {
    if (!this.form.get('videoToUpload')?.value) {
      this.deleteVideoSub = this.incidentService.deleteMedia(this.form.get('incidentId')?.value, 4).subscribe({
        next: (response) => {
          this.toast.show(response, 'success');
          this.form.get('videoId1')?.patchValue('');
          this.form.get('videoToUpload')?.patchValue('');
          this.form.get('videoPreview')?.patchValue('');
          this.form.get('videoType')?.patchValue('');
          this.selectedVideo = '';
          this.selectedVideoName = '';
          this.selectedVideoSrc = '';
          this.selectedVideoType = '';
        },
        error: (error) => {
          this.toast.show('Error deleting media', 'error');
        }
      });
    } else {
      this.form.get('videoId1')?.patchValue('');
      this.form.get('videoToUpload')?.patchValue('');
      this.form.get('videoPreview')?.patchValue('');
      this.form.get('videoType')?.patchValue('');
      this.selectedVideo = '';
      this.selectedVideoName = '';
      this.selectedVideoSrc = '';
      this.selectedVideoType = '';
    }
  }

  sizeCheck(file: any) {
    // we check to see if the file is less than 100mb :)
    if (file.size/1048576 < 100) {
      return true;
    }
    return false;
  }

  imageTypeCheck(file: any) {
    const fileTypes = [
      "image/apng",
      "image/bmp",
      "image/gif",
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "image/svg+xml",
      "image/tiff",
      "image/webp",
      "image/x-icon",
    ];
    if (fileTypes.includes(file.type)) {  
      return true;
    }
    return false;
  }

  onPhotoSelectedOne(event: any) {
    const reader = new FileReader();
    this.selectedFileOne = event.target.files[0];
    if (this.imageTypeCheck(this.selectedFileOne) === false) {
      this.selectedFileOne = null;
      this.toast.show('File must be an image', 'error');
    } else if(this.sizeCheck(this.selectedFileOne) === false) {
      this.selectedFileOne = null;
      this.toast.show('File must be under 100mb', 'error');
    } else {
      this.form.get('pic1toUpload')?.patchValue(event.target.files[0]);
      this.form.get('picId1')?.patchValue(event.target.files[0].name);
      reader.readAsDataURL(this.selectedFileOne);
      reader.onload = (event: any) => {
        this.selectedFileOneImgSrc = event.target.result;
        this.form.get('picPreview1')?.patchValue(event.target.result);
      };
      this.selectedFileOneName = event.target.files[0].name;
    }
  }

  onPhotoSelectedTwo(event: any) {
    const reader = new FileReader();
    this.selectedFileTwo = event.target.files[0];
    if (this.imageTypeCheck(this.selectedFileTwo) === false) {
      this.selectedFileTwo = null;
      this.toast.show('File must be an image', 'error');
    } else if (this.sizeCheck(this.selectedFileTwo) === true) {
      this.form.get('picId2')?.patchValue(event.target.files[0].name);
      this.form.get('pic2toUpload')?.patchValue(event.target.files[0]);
      reader.readAsDataURL(this.selectedFileTwo);
      reader.onload = (event: any) => {
        this.selectedFileTwoImgSrc = event.target.result;
        this.form.get('picPreview2')?.patchValue(event.target.result);
      };
      this.selectedFileTwoName = event.target.files[0].name;
    } else {
      this.selectedFileTwo = null;
      this.toast.show('File must be under 100mb', 'error');
    }
  }

  onPhotoSelectedThree(event: any) {
    const reader = new FileReader();
    this.selectedFileThree = event.target.files[0];
    if (this.imageTypeCheck(this.selectedFileThree) === false) {
      this.selectedFileThree = null;
      this.toast.show('File must be an image', 'error');
    } else if (this.sizeCheck(this.selectedFileThree) === true) {
      this.form.get('picId3')?.patchValue(event.target.files[0].name);
      this.form.get('pic3toUpload')?.patchValue(event.target.files[0]);
      reader.readAsDataURL(this.selectedFileThree);
      reader.onload = (event: any) => {
        this.selectedFileThreeImgSrc = event.target.result;
        this.form.get('picPreview3')?.patchValue(event.target.result);
      };
      this.selectedFileThreeName = event.target.files[0].name;
    } else {
      this.selectedFileThree = null;
      this.toast.show('File must be under 100mb', 'error');
    }
  }

  videoTypeCheck(file: any) {
    const fileTypes = [
      "video/mp4",
      "video/webm",
      "video/quicktime",
      "video/avi",
      "video/mpeg",
    ];
    if (fileTypes.includes(file.type)) {  
      return true;
    }
    return false;
  }

  onVideoSelected(event: any) {
    if (this.selectedVideoSrc) {
      this.selectedVideo = '';
      this.selectedVideoSrc = '';
    }
    const reader = new FileReader();
    this.selectedVideo = event.target.files[0];
    if (this.videoTypeCheck(this.selectedVideo) === false) {
      this.selectedVideo = null;
      this.selectedVideoName = '';
      this.toast.show('File must be a video', 'error');
    } else if (this.sizeCheck(this.selectedVideo) === false) {
      this.selectedVideo = null;
      this.selectedVideoName = '';
      this.toast.show('File must be under 100mb', 'error');
    } else {
      this.selectedVideoType = event.target.files[0].type;
      this.form.get('videoId1')?.patchValue(event.target.files[0].name);
      this.form.get('videoToUpload')?.patchValue(event.target.files[0]);
      reader.readAsDataURL(this.selectedVideo);
      reader.onload = (event: any) => {
        this.selectedVideoSrc = event.target.result;
        this.form.get('videoPreview')?.patchValue(event.target.result);
        this.form.get('videoType')?.patchValue(this.selectedVideoType);
      };
      this.selectedVideoName = event.target.files[0].name;
    }
  }

  ngOnDestroy() {
    this.deletePhotoSub?.unsubscribe();
    this.deleteVideoSub?.unsubscribe();
  }

}
